























































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import { RouterNames } from "@/router/routernames";
import { UtilsString } from "@/utils/utils-string";
import tienda_cart_module from "@/store/modules/tienda_cart_module";
import { MessageService } from "@/shared/services/message-service";
import TiendaOnlineClientesModule from "@/store/modules/TiendaOnlineClientes-module";

@Component({})
export default class CartView extends Vue {
  private selected: Record<string, boolean> = {};
  private qtys: Record<string, number> = {};
  private sortBy: string = "default";
  private promoCode: string = "";
  private snackbar: boolean = false;
  private snackbarText: string = "";
  private freeShippingThreshold: number = 0;
  private notesEdited: boolean = false;

  mounted() {
    (this.cart || []).forEach((p: any) => {
      this.$set(this.selected, p.id, false);
      if (!this.qtys[p.id]) this.$set(this.qtys, p.id, p.qty || 1);
    });
    // Precarga estados al montar
    this.preloadEstados();
  }

  get cart(): ProductoAmazon[] {
    const c = tienda_cart_module.carritoCompra;

    return Array.isArray(c) ? c : [];
  }
  get currentCart() {
    return tienda_cart_module.cartHistory.current;
  }

  get sortedCart(): ProductoAmazon[] {
    const items = [...this.cart];
    switch (this.sortBy) {
      case "price-low":
        return items.sort(
          (a, b) => Number(a.precio_venta) - Number(b.precio_venta)
        );
      case "price-high":
        return items.sort(
          (a, b) => Number(b.precio_venta) - Number(a.precio_venta)
        );
      case "name":
        return items.sort((a, b) =>
          a.titulo_producto.localeCompare(b.titulo_producto)
        );
      default:
        return items;
    }
  }

  get cartCount(): number {
    return this.cart.reduce((sum, p) => sum + (this.qtys[p.id] || 1), 0);
  }

  get selectedCount(): number {
    return Object.values(this.selected).filter((v) => v).length;
  }

  get allSelected(): boolean {
    return this.cart.length > 0 && this.selectedCount === this.cart.length;
  }

  get subtotal(): number {
    return this.cart.reduce(
      (s, p) => s + Number(p.precio_venta || 0) * (this.qtys[p.id] || 1),
      0
    );
  }

  get discount(): number {
    return 0; // Implementar lógica de descuentos
  }

  get shipping(): number {
    if (this.subtotal >= this.freeShippingThreshold) return 0;
    return this.cart.length ? 4.77 : 0;
  }

  get grandTotal(): number {
    return this.subtotal - this.discount + this.shipping;
  }

  get freeShippingRemaining(): number {
    const remaining = this.freeShippingThreshold - this.subtotal;
    return remaining > 0 ? remaining : 0;
  }

  get freeShippingProgress(): number {
    return Math.min((this.subtotal / this.freeShippingThreshold) * 100, 100);
  }

  formatPrice(val: any): string {
    const n = Number(val || 0);
    return n.toFixed(2);
  }

  toggleSelectAll() {
    const newValue = !this.allSelected;
    this.cart.forEach((p) => {
      this.$set(this.selected, p.id, newValue);
    });
  }

  removeSelected() {
    const toRemove = this.cart.filter((p) => this.selected[p.id]);
    toRemove.forEach((p) => this.remove(p));
    this.showNotification(`${toRemove.length} artículos eliminados`);
  }

  remove(product: ProductoAmazon) {
    tienda_cart_module.removeFromCart(product.id);
    this.showNotification("Artículo eliminado");
    return;
  }

  incrementQty(item: any) {
    const id = item.id;
    const current = this.qtys[id] || 1;
    this.$set(this.qtys, id, Math.min(99, current + 1));
  }

  decrementQty(item: any) {
    const id = item.id;
    const current = this.qtys[id] || 1;
    const next = Math.max(1, current - 1);
    this.$set(this.qtys, id, next);
  }

  validateQty(item: any) {
    const id = item.id;
    let val = this.qtys[id];
    if (isNaN(val) || val < 1) val = 1;
    if (val > 99) val = 99;
    this.$set(this.qtys, id, Math.floor(val));
  }

  applyPromo() {
    this.showNotification("No existe este código promocional");
    this.promoCode = "";
  }

  saveForLater() {
    MessageService.confirm(
      "¿Quieres guardar los artículos seleccionados para más tarde?",
      "Guardar para después",
      (cb: boolean) => {
        if (cb) {
          this.showNotification("Guardado en histórico de la compra");
          tienda_cart_module.finalizeCurrent(true);
          this.$router
            .push({ name: RouterNames.tienda as any })
            .catch(() => {});
        }
      }
    );
  }
  saveNotes() {
    if (this.notesEdited) {
      tienda_cart_module.save();
      this.notesEdited = false;
      this.showNotification("Comentarios guardados");
    }
  }

  viewProduct(Producto: ProductoAmazon) {
    this.$router.push({
      name: RouterNames.tienda_producto,
      params: {
        id: UtilsString.ValueOf(Producto.id),
      },
    });
  }
  checkout() {
    // número en formato internacional SIN el '+' ni espacios
    const phone = "34611425147";
    const text = `Mi carrito de la compra es el: * ${
      this.currentCart.id || "N/A"
    } *`;
    const url = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(
      text
    )}`;
    window.open(url, "_blank");
  }

  goShop() {
    this.$router.push({ name: RouterNames.tienda as any }).catch(() => {});
  }

  close() {
    this.$router.back();
  }

  showNotification(text: string) {
    this.snackbarText = text;
    this.snackbar = true;
  }

  // =====================
  //   PROCESO: estado por producto
  // =====================
  private mapEstadoToText(estado: number | null | undefined): string {
    if (estado == null) return "No disponible";
    return estado === 0 ? "Disponible" : "No disponible";
  }
  // Devuelve icono, clase de color y label desde el string ya cacheado
  private estadoUI(id: string | number) {
    const t = this.estadosProductos[id as any];
    if (!t)
      return { icon: "fa-spinner fa-pulse", cls: "muted", label: "Cargando…" };

    // Normalizamos para no depender de los asteriscos
    const base = String(t);

    if (base.startsWith("Disponible")) {
      return { icon: "fa-check-circle", cls: "ok", label: base }; // "Disponible", "Disponible *", etc.
    }
    if (base === "No por el momento") {
      return { icon: "fa-clock", cls: "warn", label: base };
    }
    if (base === "No disponible") {
      return { icon: "fa-times-circle", cls: "error", label: base };
    }
    if (base === "Desconocido") {
      return { icon: "fa-question-circle", cls: "muted", label: base };
    }

    // Fallback
    return { icon: "fa-info-circle", cls: "info", label: base };
  }
  /** Carga en bloque los estados de los productos del carrito */
  private async preloadEstados(): Promise<void> {
    try {
      const ids = new Set<string>();
      for (const it of this.cart) {
        const id = (it as any).id;
        if (id != null) ids.add(String(id));
      }

      // Sólo los que falten en cache
      const pendientes = [...ids].filter(
        (id) => !(id in this.estadosProductos)
      );
      if (pendientes.length === 0) return;

      // Marca "Cargando…" para feedback inmediato
      pendientes.forEach((id) =>
        this.$set(this.estadosProductos, id, "Cargando…")
      );

      const pendientesNum = pendientes.map(id => Number(id));

      const estadosDic = await TiendaOnlineClientesModule.getEstadosProductos(pendientesNum);
      if (estadosDic) {
          for (const idStr of Object.keys(estadosDic)) {
              const estado = estadosDic[Number(idStr)];
              this.$set(this.estadosProductos, idStr, this.mapEstadoToText(estado));
          }
      }
    } catch (e) {
      console.error("preloadEstados error", e);
    }
  }

  // 👇 Estado cacheado por id de producto
  private estadosProductos: Record<string, string> = {};
  // 🔁 Re-precarga si cambia el carrito (añadir/quitar items)
  @Watch("cart", { deep: true })
  onCartChanged() {
    this.preloadEstados();
  }
}
